import { render, staticRenderFns } from "./PersData.vue?vue&type=template&id=2bcad336&scoped=true&"
import script from "./PersData.js?vue&type=script&lang=js&"
export * from "./PersData.js?vue&type=script&lang=js&"
import style0 from "./PersData.scss?vue&type=style&index=0&id=2bcad336&lang=scss&scoped=true&"
import style1 from "./PersData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcad336",
  null
  
)

export default component.exports